/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import axios from 'axios';
import { url } from 'utils/urls';



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export const receiveDashboardMessage = () => axios.get(url.embed.dashboardMessage);
